import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbanialuxuryminibusonrent() {



    const cardData = {

keyword: "Force Urbania Luxury Mini Bus On Rent",

headingDescription:
    "Rising Cab Service offers premium Force Urbania Luxury Mini Bus On Rent for corporate travel, weddings, airport transfers, family tours, and outstation group journeys. Our Force Urbania luxury mini buses come with high-roof design, push-back reclining seats, premium interiors, powerful AC, LED lighting, ample luggage space, and experienced professional drivers. With doorstep pickup across Pune, flexible rental packages, 24/7 support, and transparent pricing, we ensure a smooth, stylish, and highly comfortable travel experience for large groups and VIP transportation needs.",

topPlaces: [
    {
        title: "Lonavala & Khandala Luxury Group Trip",
        description:
            "Lonavala and Khandala are premium hill stations near Pune known for lush valleys, waterfalls, misty mountains, and scenic viewpoints. Force Urbania luxury mini bus is perfect for large groups who want a comfortable and premium travel experience during monsoon drives and weekend luxury getaways together."
    },
    {
        title: "Mahabaleshwar Premium Tour",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, viewpoints, and cool climate. Traveling in Force Urbania luxury mini bus ensures maximum comfort for family groups, corporate teams, and wedding parties exploring scenic attractions and relaxing hill experiences."
    },
    {
        title: "Goa Luxury Beach Vacation",
        description:
            "Goa is a top long-distance luxury destination from Pune known for beaches, nightlife, and water sports. Force Urbania luxury mini bus is ideal for VIP group travel, weddings, and premium vacation tours, ensuring spacious seating and a smooth highway journey."
    },
    {
        title: "Shirdi Sai Baba Premium Darshan",
        description:
            "Shirdi is one of the most visited pilgrimage destinations in India dedicated to Sai Baba. Force Urbania luxury mini bus provides premium group travel for darshan, offering a comfortable, spacious, and relaxed journey for families and devotees."
    },
    {
        title: "Nashik Vineyard & Spiritual Luxury Tour",
        description:
            "Nashik is known for vineyards, Trimbakeshwar Jyotirlinga, and temples. Force Urbania luxury mini bus is perfect for wine tours, corporate outings, and spiritual trips, offering a premium travel experience for groups exploring vineyards and holy destinations."
    },
    {
        title: "Ashtavinayak Luxury Darshan Circuit",
        description:
            "The Ashtavinayak pilgrimage includes eight sacred Ganpati temples across Maharashtra. Force Urbania luxury mini bus is ideal for large group spiritual tours, ensuring maximum comfort, smooth travel, and a premium pilgrimage experience for devotees."
    },
    {
        title: "Alibaug Premium Coastal Escape",
        description:
            "Alibaug is a coastal destination near Mumbai known for beaches, forts, and water sports. Force Urbania luxury mini bus is perfect for premium group outings, corporate retreats, and luxury beach vacations from Pune."
    },
    {
        title: "Konkan Luxury Coastal Tour",
        description:
            "The Konkan coast including Ganpatipule, Diveagar, Harihareshwar, and Tarkarli is known for scenic beaches and greenery. Force Urbania luxury mini bus ensures a smooth and comfortable long-distance journey for luxury coastal group tours."
    },
    {
        title: "Aurangabad Heritage Luxury Trip",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, UNESCO World Heritage Sites. Force Urbania luxury mini bus is ideal for premium cultural tours, educational trips, and family heritage journeys from Pune."
    },
    {
        title: "Pune Corporate & Wedding Travel",
        description:
            "Force Urbania luxury mini bus is widely used in Pune for corporate events, wedding guest transport, and VIP group travel. It offers premium comfort, spacious seating, and a stylish travel experience for important occasions."
    }
],



services: [
{
name: "Force Urbania Luxury Mini Bus on Rent in Hadapsar",
description: "Rising Cab Service offers Force Urbania Luxury Mini Bus on Rent in Hadapsar for premium group travel needs. Ideal for corporate trips, weddings, and family tours, our Urbania vehicles provide luxury seating, AC comfort, spacious interiors, and smooth suspension. Enjoy professional drivers, punctual pickup, and safe outstation travel from Hadapsar to any destination."
},
{
name: "13 Seater Urbania Bus Hire in Kharadi",
description: "Book 13 Seater Urbania Bus Hire in Kharadi for comfortable mid-size group travel. Perfect for airport transfers, corporate travel, and family outings, this luxury vehicle offers push-back seats, ample luggage space, and smooth AC rides with experienced chauffeurs."
},
{
name: "17 Seater Urbania Bus Hire in Kharadi",
description: "Our 17 Seater Urbania Bus Hire in Kharadi is designed for larger groups seeking premium travel comfort. Ideal for long-distance tours, weddings, and corporate events, it features luxury interiors, spacious seating, and safe driving service."
},
{
name: "Luxury Bus for Corporate Events Online Bus Booking",
description: "Rising Cab Service provides Luxury Bus for Corporate Events Online Bus Booking with seamless reservation options. Perfect for office outings, meetings, and employee transportation, our luxury buses ensure punctuality, comfort, and professional service."
},
{
name: "Pune Airport Urbania Bus on Rent",
description: "Book Pune Airport Urbania Bus on Rent for smooth and comfortable group airport transfers. We provide timely pickup, spacious luggage capacity, and luxury seating for families, corporate teams, and travel groups."
},
{
name: "Pune to Mumbai Airport Urbania Bus on Rent",
description: "Our Pune to Mumbai Airport Urbania Bus on Rent service ensures stress-free intercity airport travel. Enjoy comfortable seating, AC interiors, and professional drivers for safe and timely airport transfers."
},
{
name: "Force Urbania Luxury Mini Bus on Rent for Outstation",
description: "Rising Cab Service offers Force Urbania Luxury Mini Bus on Rent for Outstation travel including hill stations, pilgrimage tours, and long-distance trips. Experience premium comfort, safety, and smooth rides with expert chauffeurs."
},
{
name: "Urbania Bus Hire in Hinjewadi",
description: "Book Urbania Bus Hire in Hinjewadi for corporate and group travel with luxury comfort. Ideal for IT professionals, company outings, and family trips with spacious seating and reliable service."
},
{
name: "Urbania Bus Hire in Aundh Baner",
description: "Our Urbania Bus Hire in Aundh Baner offers premium transportation for weddings, corporate travel, and outstation tours. Enjoy luxury interiors, AC comfort, and professional drivers for a smooth journey."
},
{
name: "Urbania Bus on Rent for Pune to Shirdi Darshan",
description: "Rising Cab Service provides Urbania Bus on Rent for Pune to Shirdi Darshan for devotional group travel. Travel comfortably to Sai Baba Temple with spacious seating, AC vehicles, and experienced drivers."
},
{
name: "Force Urbania on Rent in Pune Airport",
description: "Book Force Urbania on Rent in Pune Airport for convenient and luxury group pickups. Perfect for tourists and corporate teams arriving at Pune with doorstep pickup and premium comfort."
},
{
name: "Force Urbania on Rent in Pune Airport Near Me",
description: "Get Force Urbania on Rent in Pune Airport Near Me for quick and reliable luxury transportation. We offer 24x7 availability, comfortable seating, and professional chauffeurs for seamless travel."
},
{
name: "Force Urbania on Rent in Pimpri Chinchwad",
description: "Rising Cab Service provides Force Urbania on Rent in Pimpri Chinchwad for weddings, corporate tours, and family travel. Enjoy spacious luxury seating and smooth outstation journeys."
},
{
name: "Force Urbania on Rent in Pimpri Chinchwad Near Me",
description: "Book Force Urbania on Rent in Pimpri Chinchwad Near Me for instant luxury bus service. Ideal for group travel with AC comfort, reliable drivers, and flexible booking options."
},
{
name: "Force Urbania on Rent in Magarpatta City",
description: "Our Force Urbania on Rent in Magarpatta City service is perfect for IT professionals, corporate groups, and family travel. Enjoy premium interiors, punctual service, and safe transportation."
}
],

tableData: [
["Force Urbania Luxury Mini Bus on Rent in Hadapsar","13 Seater Urbania Bus Hire in Kharadi"],
["17 Seater Urbania Bus Hire in Kharadi","Luxury Bus for Corporate Events Online Bus Booking"],
["Pune Airport Urbania Bus on Rent","Pune to Mumbai Airport Urbania Bus on Rent"],
["Force Urbania Luxury Mini Bus on Rent for Outstation","Urbania Bus Hire in Hinjewadi"],
["Urbania Bus Hire in Aundh Baner","Urbania Bus on Rent for Pune to Shirdi Darshan"],
["Force Urbania on Rent in Pune Airport","Force Urbania on Rent in Pune Airport Near Me"],
["Force Urbania on Rent in Pimpri Chinchwad","Force Urbania on Rent in Pimpri Chinchwad Near Me"],
["Force Urbania on Rent in Magarpatta City",""]
],




whychoose: [
    {
        WhyChooseheading: "Premium Force Urbania Luxury Mini Bus on Rent",
        WhyChoosedescription: "Rising Cab Service offers Force Urbania Luxury Mini Bus rental services for family vacations, corporate travel, weddings, airport transfers, pilgrimages, and premium group transportation."
    },
    {
        WhyChooseheading: "Luxury Interiors with Superior Comfort",
        WhyChoosedescription: "Force Urbania features premium pushback seats, spacious cabin design, ample legroom, elegant interiors, and modern amenities for a luxury travel experience."
    },
    {
        WhyChooseheading: "Ideal for Corporate and Executive Travel",
        WhyChoosedescription: "The Luxury Urbania Mini Bus is perfect for corporate events, executive transportation, VIP guest transfers, business tours, and professional group travel."
    },
    {
        WhyChooseheading: "Available for Local and Outstation Trips",
        WhyChoosedescription: "Urbania rentals are available for Pune city travel and outstation destinations including Goa, Mahabaleshwar, Shirdi, Nashik, Mumbai, Konkan, Kolhapur, and more."
    },
    {
        WhyChooseheading: "Spacious Seating and Premium Features",
        WhyChoosedescription: "Passengers enjoy comfortable seating, wide windows, excellent air conditioning, luggage space, charging points, and a smooth travel experience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Force Urbania pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Safe Journeys",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, timely service, smooth highway travel, and a comfortable journey throughout the trip."
    },
    {
        WhyChooseheading: "Best Choice for Luxury Group Travel",
        WhyChoosedescription: "Force Urbania is widely preferred for destination weddings, family tours, corporate outings, pilgrimage tours, sightseeing trips, and luxury vacations."
    }
]
};

const faqData = [
    {
        question: "What is Force Urbania Luxury Mini Bus on Rent?",
        answer: "Force Urbania is a premium luxury passenger vehicle designed for comfortable group travel with spacious seating and modern travel amenities."
    },
    {
        question: "Can I hire Force Urbania for outstation travel?",
        answer: "Yes, Force Urbania Luxury Mini Buses are available for outstation tours across Maharashtra and other states."
    },
    {
        question: "Is Force Urbania suitable for corporate travel?",
        answer: "Yes, Urbania is one of the most preferred luxury vehicles for executive transportation, business tours, and corporate events."
    },
    {
        question: "Can Force Urbania be booked for weddings?",
        answer: "Yes, Urbania is commonly hired for wedding guest transportation, destination weddings, and family functions."
    },
    {
        question: "Is the vehicle comfortable for long-distance journeys?",
        answer: "Yes, the spacious cabin, premium seats, and luxury features make it ideal for long-distance travel."
    },
    {
        question: "Can families hire Force Urbania for vacations?",
        answer: "Yes, Urbania is an excellent choice for family holidays, group tours, and sightseeing trips."
    },
    {
        question: "Do you provide Force Urbania for pilgrimage tours?",
        answer: "Yes, Urbania vehicles are available for Shirdi, Ashtavinayak, Pandharpur, Tuljapur, Akkalkot, Jyotirlinga, and other religious tours."
    },
    {
        question: "Are airport transfer services available with Force Urbania?",
        answer: "Yes, Force Urbania can be booked for Pune Airport transfers, Mumbai Airport transfers, and VIP guest transportation."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Force Urbania Luxury Mini Bus on Rent?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akash Patwardhan",
        feedback:
            "We hired the Force Urbania for a family Goa trip and were impressed by the premium seating, spacious interiors, and overall luxury travel experience.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sonali Jagtap",
        feedback:
            "Our corporate team used the Urbania for an outstation conference. The vehicle was luxurious, comfortable, and perfect for executive group travel.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Force Urbania Luxury Mini Bus on Rent in Pune",
"image": "https://www.risingcabservice.com/assets/images/urbania-luxury-mini-bus-pune.jpg",
"description": "Book Force Urbania Luxury Mini Bus on Rent in Pune with Rising Cab Service for premium group travel, corporate events, airport transfers, weddings, and outstation tours. Available in 13 and 17 seater luxury AC vans with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹28/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/force-urbania-luxury-mini-bus-on-rent-pune"
}
};








    return (
        <div>

<Helmet>
  <title>Force Urbania Luxury Mini Bus on Rent in Pune | Premium Travel Van | +91 9272511548</title>

<meta
 name="description"
 content="Book Force Urbania Luxury Mini Bus on Rent in Pune for corporate events, airport transfers, weddings, and outstation travel. Get 13 & 17 seater luxury AC vans with driver."
/>

<meta
 name="keywords"
 content="force urbania luxury mini bus on rent, urbania bus hire hadapsar, urbania bus kharadi, 13 seater urbania kharadi, 17 seater urbania kharadi, pune airport urbania bus, pune to mumbai airport urbania, urbania bus hire hinjewadi, urbania baner aundh, urbania pune to shirdi, force urbania pimpri, luxury mini bus pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/74.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Forceurbanialuxuryminibusonrent;